import { Icon } from '@iconify/react/dist/iconify.js';
import React from 'react';
import { Link, useNavigate, useSearchParams } from 'react-router-dom';
import Pagination from './child/Pagination';
import { useAuth } from '../context/AuthContext';
import { statusPedidoNome } from '../helper/helpers';
import { formatCurrency } from '../helper/currency';
import { useConfirm } from '../context/BootstrapConfirm';
import useErrors from '../hook/useErrors';
import server from '../services/server';

const PedidosListLayer = ({ data, mutate }) => {
    const [searchParams, setSearchParams] = useSearchParams();
    const currentPage = Number(searchParams.get('page')) || 1;
    const navigate = useNavigate();
    const { user } = useAuth();
    const isAdmin = user?.funcao === 'ADMIN';
    const confirm = useConfirm();
    const { setErrors, toast } = useErrors();

    const handlePageChange = page => {
        setSearchParams({
            ...Object.fromEntries(searchParams),
            page,
        });
    };

    function handleChangeStatus(e) {
        const currentParams = Object.fromEntries(searchParams);
        const newStatus = e.target.value;

        if (Boolean(newStatus)) {
            currentParams.status = newStatus;
        } else {
            delete currentParams.status; // Remove o parâmetro da URL
        }

        setSearchParams(currentParams);
    }

    function handleChangeName(e) {
        const currentParams = Object.fromEntries(searchParams);

        if (e.target.value.trim().length > 0) {
            currentParams.nome = e.target.value;
        } else {
            delete currentParams.nome;
        }
        setSearchParams(currentParams);
    }

    function handleClick(id) {
        navigate(`/pedidos/${id}`);
    }

    function handleClearFilters() {
        setSearchParams({});
    }

    async function handleDelete(e, id) {
        e.stopPropagation();
        try {
            await confirm({
                title: 'Excluir pedido',
                message: `Tem certeza que deseja excluir o pedido #${id}? Essa ação não pode ser desfeita.`,
                confirmText: 'Excluir',
            });
            await server.delete(`pedido/${id}`);
            toast.success('Pedido excluído com sucesso!');
            if (typeof mutate === 'function') mutate();
        } catch (error) {
            if (error) setErrors(error);
        }
    }

    function formatDate(value) {
        if (!value) return '-';
        return new Date(value).toLocaleDateString('pt-BR');
    }

    return (
        <div className="card h-100 p-0 radius-12">
            <div className="card-header border-bottom bg-base py-16 px-24 d-flex align-items-center flex-wrap gap-3 justify-content-between">
                <div className="d-flex align-items-center flex-wrap gap-3">
                    <div className="d-flex flex-wrap align-items-center gap-3">
                        <select className="form-select form-select-sm w-auto" onChange={handleChangeStatus} value={searchParams.get('status') || ''}>
                            <option value="">Todos os status</option>
                            {Object.entries(statusPedidoNome).map(([chave, valor]) => (
                                <option key={chave} value={chave}>
                                    {valor}
                                </option>
                            ))}
                        </select>
                    </div>
                    <form className="navbar-search">
                        <input type="text" className="bg-base h-40-px w-auto" onChange={handleChangeName} name="search" placeholder="Buscar pedido ou cliente" value={searchParams.get('nome') || ''} />
                        <Icon icon="ion:search-outline" className="icon" />
                    </form>
                    <button type="button" className="btn btn-outline-neutral-500 btn-sm" onClick={handleClearFilters}>
                        Limpar
                    </button>
                </div>
                {isAdmin && (
                    <Link to="add" className="btn btn-primary-600 btn-sm">
                        <Icon icon="ic:baseline-plus" className="icon text-xl line-height-1" />
                        Novo pedido
                    </Link>
                )}
            </div>
            <div className="card-body p-24">
                <div className="table-responsive scroll-sm">
                    <table className="table bordered-table sm-table mb-0">
                        <thead>
                            <tr>
                                <th scope="col">Id</th>
                                <th scope="col">Cliente</th>
                                <th scope="col">Valor</th>
                                <th scope="col">Data de criação</th>
                                <th scope="col">Status</th>
                                <th scope="col"> </th>
                            </tr>
                        </thead>
                        <tbody>
                            {Boolean(data) &&
                                data?.pedidos?.map(item => (
                                    <tr onClick={() => handleClick(item.id)}>
                                        <td>{item.id}</td>
                                        <td>
                                            <span className="text-md mb-0 fw-normal text-secondary-light">{item?.cliente?.nome}</span>
                                        </td>

                                        <td>{formatCurrency(item.valorTotal)}</td>
                                        <td>{formatDate(item.dataCriacao)}</td>

                                        <td>
                                            {statusPedidoNome[item.status]}
                                        </td>

                                        <td className="text-center">
                                            <div className="d-flex align-items-center gap-10 justify-content-center">
                                                <Link
                                                    to={`${item.id}`}
                                                    className="bg-success-focus text-success-600 bg-hover-success-200 fw-medium w-40-px h-40-px d-flex justify-content-center align-items-center rounded-circle"
                                                >
                                                    <Icon icon="lucide:edit" className="menu-icon" />
                                                </Link>
                                                {isAdmin && (
                                                    <button
                                                        type="button"
                                                        title="Excluir pedido"
                                                        onClick={(e) => handleDelete(e, item.id)}
                                                        className="bg-danger-focus text-danger-600 bg-hover-danger-200 fw-medium w-40-px h-40-px d-flex justify-content-center align-items-center rounded-circle border-0"
                                                    >
                                                        <Icon icon="mingcute:delete-2-line" className="menu-icon" />
                                                    </button>
                                                )}
                                            </div>
                                        </td>
                                    </tr>
                                ))}
                        </tbody>
                    </table>
                </div>
                <div className="d-flex flex-wrap align-items-center justify-content-between gap-2 mt-24">
                    <span>
                        {' '}
                        Mostrando {data?.itens_per_page} de {data?.total} {data?.itens_per_page > 1 ? 'itens' : 'item'}{' '}
                    </span>
                    {data?.pages > 1 && <Pagination page={data.currentPage} pages={data?.pages} onPageChange={handlePageChange} />}
                </div>
            </div>
        </div>
    );
};

export default PedidosListLayer;
